// src/pages/Login.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../utils/AuthContext';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
import axios from '../utils//axios';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Login.css";

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [setlang, setLang] = useState("fa")
  const [loading, setLoading] = useState(false);
  const { lang } = useParams();
  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname || `/${lang}/profile`; 


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      postMessage('Logged in!');
      navigate(from, { replace: true }); 
      window.location.reload(); 

    } catch (err) {
      const code = err?.response?.data?.code;
      const status = err?.response?.status;
      
      if (!err?.response) {
        alert(setlang==="en"?'Server error, please try again later':'مشکلی رخ داد');
      } else if (err.response.status >= 500) {
        alert(setlang==="en"?'Server error, please try again later':'مشکلی در برقراری ارتباط با سیستم رخ داد، لطفا دوباره وارد شو');
      } else {
        alert(setlang==="en"?'Invalid username or password':'نام کاربری و یا کلمه عبور صحیح نیست');
      }

    } finally {
      setLoading(false);
    }
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  return (
    <>
      <NavbarLog />      
      <div className="center-wrapper">
        <div className="container">
          {setlang === "en" ? 
          <h2 className= "login-heading">Login</h2>:
          <h2 className= "login-heading">ورود</h2>
          }
          {setlang === "en" ? 
          <form className="form" onSubmit={handleSubmit}>
            <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Your email" />
            <input value={password} type="password" onChange={e => setPassword(e.target.value)} placeholder="Password" />
            <button className="btn-submit" type="submit" disabled={loading} >{loading ? 'Logging in...' : 'Login'}</button>
          </form>
          :
          <form className="form" onSubmit={handleSubmit}>
            <input value={username} onChange={e => setUsername(e.target.value)} placeholder="ایمیل" />
            <input value={password} type="password" onChange={e => setPassword(e.target.value)} placeholder="رمز عبور" />
            <button className="btn-submit" type="submit" disabled={loading} >{loading ? 'در حال ورود ...' : 'ورود'}</button>
          </form>
          }

          {loading && (
            <div className="loading-overlay">
              <div className="loading-box" style={{ '--spinner-size': '60px' }}>
                <div className="spinner" />
                <span>{setlang === "en" ? 'Loading...':'... در حال بارگذاری'}</span>
              </div>
            </div>
          )}

          {setlang === "en" ? 
          <div className='registration-text'>
           If you do not have an account, please <Link to={`/${lang}/register`}> register here</Link>!
          </div>
          :
          <div className='registration-text'>
          ! اگر حساب کاربری ندارید، لطفا <Link to={`/${lang}/register`}>اینجا ثبت نام کنید</Link>
          </div>
          }
        </div>
      </div>
      <Footer />
    </>

  );
}

export default Login;
